<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Employment Datasheet</h3>
       </template>
       <nav class="row">
          <ol class="breadcrumb arr-right bg-breadcrum">
             <li class="breadcrumb-item">
                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp; Dashboard</router-link>
             </li>
             <li class="breadcrumb-item active">New Employee</li>
          </ol>
       </nav>
       <hr style="margin-top:-10px"/>
       <form @submit="formSubmit">
          <div class="row">
             <div class="col-md-12">
                <!-- WORKSHIFT-->   
                <font color="#4285f4" class="title-section"><i class="fa fa-clock-o"></i> Work Shift</font> <font size="2" color="red" class="float-right">(*) All Fields Are Required</font>
                <div class="border-box-new-employee">
                   <div class="row">
                      <div class="col-md-4">
                         <div class="form-group">
                            <label>Schedule Type</label>
                            <select 
                               v-model="selectedSched" 
                               class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.schedule}"
                               @click="hide_message_scheduleType"
                               >
                               <option value="">-- Select Schedule --</option>
                               <option v-for="(sched_obj, sched_index) in schedules" :value="sched_index">{{sched_index}}</option>
                            </select>
                            <span v-if="error_handler.schedule" class="invalid-feedback">{{ error_handler.schedule[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                           <label>Time</label>
                           <select 
                              :disabled="sched_items.length == 0" 
                              v-model="selectedTime" 
                              class="form-control" 
                              v-bind:class="{ 'is-invalid': error_handler && error_handler.time}"
                              @click="hide_message_scheduleTime"  
                              >
                              <option value="">-- Select Time --</option>
                              <option v-for="(time_obj, time_index) in sched_items" :value="time_obj.time">{{time_obj.time}}</option>
                           </select>
                           <span v-if="error_handler.time" class="invalid-feedback">{{ error_handler.time[0] }}</span>
                        </div>
                     </div>
                     <div class="col-md-4">
                      <div class="form-group">
                        <label>Timezone</label>
                        <select 
                           v-model="timezoneId" 
                           v-bind:class="{ 'is-invalid': error_handler && error_handler.timezone_id}" 
                           class="form-control"
                           @click="hide_message_timezone_id"
                           >
                           <option disabled value="">-- Please select one --</option>
                           <option v-for="time in timezoneItem" v-bind:value="time.id" v-text="time.timezone_name"></option>
                        </select>
                        <span v-if="error_handler.timezone_id" class="invalid-feedback">{{ error_handler.timezone_id[0] }}</span> 
                      </div>
                    </div>
                   </div>
                </div>
                <br/>
                <!-- JOB INFORMATION -->  
                <font color="#4285f4" class="title-section"><i class="fa fa-info-circle"></i> Job Information</font><font size="2" color="red" class="float-right">(*) All Fields Are Required</font>
                <div class="border-box-new-employee">
                   <div class="row">
                      <div class="col-md-2">
                         <div class="form-group"> 
                            <label>Employee No </label> 
                            <input  
                               v-mask="['####-###']"  
                               class="form-control" 
                               v-model="emp_id" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.emp_id}" 
                               placeholder="Ex.100035"
                               @click="hide_message_employeeNo"  
                               >
                            <span v-if="error_handler.emp_id" class="invalid-feedback">{{ error_handler.emp_id[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="form-group">
                            <label>Sub Department Belong</label>
                            <select 
                               v-model="sub_department_id" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.sub_department_id}" 
                               class="form-control"
                               @click="hide_message_departmentBelong"
                               >
                               <option disabled value="">-- Please select one --</option>
                               <option v-for="sub in subDepartmentItem" v-bind:value="sub.id" v-text="sub.sub_department_name"></option>
                            </select>
                            <span v-if="error_handler.sub_department_id" class="invalid-feedback">{{ error_handler.sub_department_id[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="form-group">
                            <label>Job Title / Position</label>
                            <select 
                               v-model="position_id" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.position_id}" 
                               class="form-control"
                               @click="hide_message_position"
                               >
                               <option disabled value="">-- Please select one --</option>
                               <option v-for="pos in positionsItem" v-bind:value="pos.id" v-text="pos.position_name"></option>
                            </select>
                            <span v-if="error_handler.position_id" class="invalid-feedback">{{ error_handler.position_id[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group">
                            <label><i class="fa fa-money"></i>&nbsp; Basic Salary </label>
                            <input 
                              type="number" 
                              v-model="basic_salary" 
                              class="form-control" 
                              v-bind:class="{ 'is-invalid': error_handler && error_handler.basic_salary}"
                              @click="hide_message_salary" 
                              v-mask="['#########']" 
                              placeholder="0.00"
                            >
                            <span v-if="error_handler.basic_salary" class="invalid-feedback">{{ error_handler.basic_salary[0] }}</span> 
                         </div>
                         <template v-if="basic_salary == '0'">
                                 <input type="number" v-model="others_salary" v-mask="['#########']"  class="form-control" placeholder="0.00">
                         </template>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group">
                            <label><i class="fa fa-money"></i>&nbsp; Allowance </label>
                            <input 
                              type="number" 
                              v-model="monthly_allowance" 
                              class="form-control" 
                              v-bind:class="{ 'is-invalid': error_handler && error_handler.monthly_allowance}"
                              @click="hide_message_allowance" 
                              v-mask="['#########']" 
                              placeholder="0.00"
                            >
                            <span v-if="error_handler.monthly_allowance" class="invalid-feedback">{{ error_handler.monthly_allowance[0] }}</span> 
                         </div>
                         <template v-if="monthly_allowance == '0'">
                          <input type="number" v-model="others_allowance"  v-mask="['#########']" class="form-control" placeholder="0.00">
                        </template>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-md-4">
                         <div class="form-group"> 
                            <label><i class="fa fa-calendar"></i>&nbsp; Date Hired </label>
                            <input 
                               type="date" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.employment_date}" 
                               v-model="employment_date" 
                               class="form-control" 
                               @click="hide_message_dateHired"
                               > 
                            <span v-if="error_handler.employment_date" class="invalid-feedback">{{ error_handler.employment_date[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-4">
                         <div class="form-group"> 
                            <label><i class="fa fa-calendar"></i>&nbsp; Date Signed </label>
                            <input type="date" v-model="date_sign" class="form-control" >
                         </div>
                      </div>
                      <div class="col-md-4">
                         <div class="form-group"> 
                            <label><i class="fa fa-calendar"></i>&nbsp; Training Startdate </label>
                            <input type="date" v-model="training_date" class="form-control" >
                         </div>
                      </div>
                   </div>
                </div>
                <br/>
                <!-- PERSONAL INFORMATION      -->
                <font color="#4285f4" class="title-section"><i class="fa fa-user "></i> Personal Information</font><font size="2" color="red" class="float-right">(*) All Fields Are Required</font>
                <br/>
                <div class="border-box-new-employee">
                   <div class="row">
                      <div class="col-md-2">
                         <div class="form-group"> 
                            <label>First name </label>
                            <input 
                               type="text" 
                               class="form-control"  
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.first_name}" 
                               v-model="first_name" pattern="[A-Za-z ]{1,32}" 
                               placeholder="Ex.Juan"
                               @click="hide_message_firstName"
                               >
                            <span v-if="error_handler.first_name" class="invalid-feedback">{{ error_handler.first_name[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group"> 
                            <label>Last name : </label>
                            <input 
                               type="text" 
                               class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.last_name}" 
                               v-model="last_name" 
                               pattern="[A-Za-z ]{1,32}" 
                               placeholder="Ex.Dela Cruz"
                               @click="hide_message_lastName"
                               >
                            <span v-if="error_handler.last_name" class="invalid-feedback">{{ error_handler.last_name[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group"> 
                            <label>Middle name : </label>
                            <input 
                               type="text" 
                               class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.middle_name}" 
                               v-model="middle_name" 
                               pattern="[A-Za-z ]{1,32}" 
                               placeholder="Ex.Dalisay"
                               @click="hide_message_middleName"
                               >
                            <span v-if="error_handler.middle_name" class="invalid-feedback">{{ error_handler.middle_name[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group">
                            <label>Suffix : </label>
                            <select class="form-control" v-model="suffix">
                               <option value="" disabled>Choose</option>
                               <option value="Jr">Jr</option>
                               <option value="Sr">Sr</option>
                               <option value="I">I</option>
                               <option value="II">II</option>
                               <option value="III">III</option>
                               <option value="IV">IV</option>
                               <option value="IV">V</option>
                            </select>
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group">
                            <label>Civil Status : </label>
                            <select 
                               class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.civil_status}"  
                               v-model="civil_status"
                               @click="hide_message_civilStatus"
                               >
                               <option value="" disabled>Choose</option>
                               <option value="single">Single</option>
                               <option value="married">Married</option>
                               <option value="divorced">Divorced</option>
                               <option value="widowed">Widowed</option>
                            </select>
                            <span v-if="error_handler.civil_status" class="invalid-feedback">{{ error_handler.civil_status[0] }}</span> 
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group"> 
                            <label><i class="fa fa-calendar"></i>&nbsp; Birth date : </label>
                            <input 
                               type="date" 
                               class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.birthdate}" 
                               v-model="birthdate" 
                               @click="hide_message_birthDate"
                               >
                            <span v-if="error_handler.birthdate" class="invalid-feedback">{{ error_handler.birthdate[0] }}</span>
                         </div>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-md-12">
                         <div class="form-group"> 
                            <label><i class="fa fa-map-marker"></i>&nbsp; Current Address : </label>
                            <input 
                               type="text" class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.current_address}" 
                               v-model="current_address"
                               @click="hide_message_currentAddress"
                               >
                            <span v-if="error_handler.current_address" class="invalid-feedback">{{ error_handler.current_address[0] }}</span>
                         </div>
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-md-12">
                         <div class="form-group"> 
                            <label><i class="fa fa-map-marker"></i>&nbsp; Permanent address : </label>
                            <input 
                               type="text" 
                               class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.permanent_address}" 
                               v-model="permanent_address" 
                               @click="hide_message_permanentAddress"
                               >
                            <span v-if="error_handler.permanent_address" class="invalid-feedback">{{ error_handler.permanent_address[0] }}</span>
                         </div>
                      </div>
                   </div>
                </div>
                <br/> 
                <!-- CONTACT INFORMATION -->      
                <font color="#4285f4" class="title-section"><i class="fa fa-address-book-o"></i> Contact Information</font><font size="2" color="red" class="float-right">(*) All Fields Are Required</font>
                <br/>
                <div class="border-box-new-employee">
                   <div class="row">
                      <div class="col-md-2">
                         <div class="form-group"> 
                            <label><i class="fa fa-phone"></i>&nbsp; Contact no.  </label>
                            <input 
                               type="tel" 
                               v-mask="['####-########']"  
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.contact}" 
                               class="form-control"  
                               v-model="contact"
                               @click="hide_message_contactNo"
                               />
                            <span v-if="error_handler.contact" class="invalid-feedback">{{ error_handler.contact[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="form-group"> 
                            <label>Personal Email address : </label>
                            <input 
                               type="email" 
                               v-model="email_address" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.email_address}" 
                               class="form-control" 
                               placeholder="Ex.juandelacrus@gmail.com"
                               @click="hide_message_personalEmail"
                               >
                            <span v-if="error_handler.email_address" class="invalid-feedback">{{ error_handler.email_address[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group"> 
                            <label><i class="fa fa-phone"></i>&nbsp;Emergency No</label>
                            <input 
                               type="tel" 
                               v-mask="['####-########']" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.emergency_no}" 
                               class="form-control" 
                               v-model="emergency_no"
                               @click="hide_message_emergencyNo"
                               />
                            <span v-if="error_handler.emergency_no" class="invalid-feedback">{{ error_handler.emergency_no[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="form-group"> 
                            <label>Contact Person</label>
                            <input 
                               type="text" 
                               class="form-control" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.contact_person}" 
                               v-model="contact_person" 
                               placeholder="Ex.Juan Dela Cruz" 
                               @click="hide_message_contactPerson"
                               >
                            <span v-if="error_handler.contact_person" class="invalid-feedback">{{ error_handler.contact_person[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group">
                            <label>Relationship : </label>
                            <select 
                               class="form-control" 
                               v-model="relationship" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.relationship}"
                               @click="hide_message_relationship" 
                               >
                               <option disabled value="">-- Please select one --</option>
                               <option value="Mother">Mother</option>
                               <option value="Father">Father</option>
                               <option value="Father">Daughter</option>
                               <option value="Son">Son</option>
                               <option value="Sister">Sister</option>
                               <option value="Brother">Brother</option>
                               <option value="Aunt">Aunt</option>
                               <option value="Uncle">Uncle</option>
                               <option value="Niece">Niece</option>
                               <option value="Nephew">Nephew</option>
                               <option value="Sibling">Sibling</option>
                               <option value="Sibling">Guardian</option>
                               <option value="Live in Partner">Live in Partner</option>
                               <option value="Cousin(Female)">Cousin(Female)</option>
                               <option value="Cousin(Male)">Cousin(Male)</option>
                               <option value="Grandmother">Grandmother</option>
                               <option value="Brother">Grandfather</option>
                               <option value="Granddaughter">Granddaughter</option>
                               <option value="Grandson">Grandson</option>
                               <option value="Stepsister">Stepsister</option>
                               <option value="Stepbrother">Stepbrother</option>
                               <option value="Stepmother">Stepmother</option>
                               <option value="Stepfather">Stepfather</option>
                               <option value="Girlfreind">Girlfreind</option>
                               <option value="Boyfreind">Boyfreind</option>
                               <option value="Wife">Wife</option>
                               <option value="Husband">Husband</option>
                            </select>
                            <span v-if="error_handler.relationship" class="invalid-feedback">{{ error_handler.relationship[0] }}</span>
                         </div>
                      </div>
                   </div>
                </div>
                <br/>  
                <!-- EMPLOYEE EXPERIENCE -->  
                <font color="#4285f4" class="title-section"> <i class="fa fa-wpforms"></i> Employee Experience</font><font size="2" color="red" class="float-right">(*) All Fields Are Optional</font>
                <div v-for="(epx ,index) in experience">
                   <div class="border-box-new-employee">
                      <div class="row">
                         <div class="col-md-4">
                            <div class="form-group">  
                               <label>Employeer</label> 
                               <input v-model="epx.employeer" class="form-control">
                            </div>
                         </div>
                         <div class="col-md-4">
                            <div class="form-group">  
                               <label>Company Address</label>    
                               <input v-model="epx.company_address" class="form-control">
                            </div>
                         </div>
                         <div class="col-md-4">
                            <div class="form-group">  
                               <label>Job Title / Position</label>    
                               <input v-model="epx.job_title" class="form-control">
                            </div>
                         </div>
                      </div>
                      <div class="row">
                         <div class="col-md-4">
                            <div class="form-group">  
                               <label>Start Date</label>    
                               <input type="date" v-model="epx.start_date" class="form-control">
                            </div>
                         </div>
                         <div class="col-md-4">
                            <div class="form-group">  
                               <label>End Date</label>    
                               <input type="date" v-model="epx.end_date" class="form-control">
                            </div>
                         </div>
                         <div class="col-md-4">
                            <div class="form-group">  
                               <label>Previous Salary</label>    
                               <input v-model="epx.previous_salary" v-mask="['##,###.00']" class="form-control">
                            </div>
                         </div>
                      </div>
                      <div class="row">
                         <div class="col-md-12">
                            <div class="form-group">
                               <label>Reason for leaving</label>
                               <textarea rows="5" v-model="epx.reason_for_leaving" class="form-control"></textarea>
                            </div>
                         </div>
                      </div>
                      <div class="floater-point-exp">
                         <div class="action-item-exp-employee">
                            <div class="form-group">
                               <br/>
                               <button @click.stop.prevent="add_experience" class="btn btn-xs btn-primary" v-b-tooltip.hover title="click to add new employee experience section"><i class="fa fa-plus"></i></button>
                               <button @click.stop.prevent="deleteUser(index)" class="btn btn-xs btn-primary" v-b-tooltip.hover title="click to remove employee experience section"><i class="fa fa-minus"></i></button>
                            </div>
                         </div>
                      </div>
                   </div>
                   <br/>
                </div>
                <!-- EMPLOYEE BENEFITS -->    
                <font color="#4285f4" class="title-section"><i class="fa fa-hospital-o"></i> Employee Benefits</font> <font size="2" color="red" class="float-right">Note: (*) To be filled out later </font>
                <div class="border-box-new-employee">
                   <div class="row">
                      <div class="col-md-2">
                         <div class="form-group">
                            <label>SSS No</label>
                            <the-mask 
                               :mask="['##-#######-#']" 
                               placeholder="00-0000000-0" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.sss_no}" 
                               class="form-control" 
                               v-model="sss_no"
                               />
                            <span v-if="error_handler.sss_no" class="invalid-feedback">{{ error_handler.sss_no[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="form-group">
                            <label>HDMF No</label>
                            <the-mask 
                               :mask="['####-####-####']" 
                               placeholder="0000-0000-0000" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.hdmf_no}" 
                               class="form-control" 
                               v-model="hdmf_no"
                               />
                            <span v-if="error_handler.hdmf_no" class="invalid-feedback">{{ error_handler.hdmf_no[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="form-group">
                            <label>MID No</label>
                            <the-mask 
                               :mask="['####-####-####']" 
                               placeholder="0000-0000-0000" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.mid_no}" 
                               class="form-control" 
                               v-model="mid_no"
                               />
                            <span v-if="error_handler.mid_no" class="invalid-feedback">{{ error_handler.mid_no[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group">
                            <label>TIN No</label>
                            <the-mask 
                               :mask="['###-###-###']" 
                               placeholder="000-000-000" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.tin_no}" 
                               class="form-control" 
                               v-model="tin_no"
                               />
                            <span v-if="error_handler.tin_no" class="invalid-feedback">{{ error_handler.tin_no[0] }}</span>
                         </div>
                      </div>
                      <div class="col-md-2">
                         <div class="form-group">
                            <label>PHIC No</label>
                            <the-mask 
                               :mask="['##-#########-#']" 
                               placeholder="00-000000000-0" 
                               v-bind:class="{ 'is-invalid': error_handler && error_handler.phic_no}" 
                               class="form-control" 
                               v-model="phic_no"/>
                            <span v-if="error_handler.phic_no" class="invalid-feedback">{{ error_handler.phic_no[0] }}</span>
                         </div>
                      </div>
                   </div>
                </div>
                <br/> 
                <div class="col-md-4 float-right">
                   <div class="row">
                      <div class="col-md-6">   
                         <button class="btn btn-danger" @click="resForm" style="width: 100%"><i class="fa fa-refresh"></i> Reset all fields</button> 
                      </div>
                      <div class="col-md-6">
                         <button class="btn btn-info" style="width: 100%"><i class="fa fa-save"></i> Save Datasheet</button> 
                      </div>
                   </div>
                </div>
                <br/> <br/>   <br/>  <br/>  
             </div>
          </div>
       </form>
    </card>
 </template>
<script>
 /* eslint-disable */
 import Card from 'src/components/UIComponents/Cards/Card.vue'
 import {mapState} from 'vuex'
 export default {
  components: {
    Card
  },
  data() {
    return {
       schedules: {
        "Day-Shift": [
          {
            "time": "5AM - 2PM"
          },
          {
            "time": "6AM - 3PM"
          },
          {
            "time": "7AM - 4PM"
          },
          {
            "time": "8AM - 5PM"
          },
          {
            "time": "9AM - 6PM"
          },
          {
            "time": "10AM - 7PM"
          },
          {
            "time": "11AM - 8PM"
          },
          {
            "time": "12NN - 9PM"
          },
          {
            "time": "1PM - 10PM"
          },
          {
            "time": "2PM - 11PM"
          },
          {
            "time": "3PM - 12NN"
          },

        ],
        "Mid-Shift": [{
            "time": "11PM - 8AM"
          },
          {
            "time": "12NN - 9AM"
          },
          {
            "time": "1AM - 10AM"
          },
          {
            "time": "2AM - 11AM"
          },
          {
            "time": "3AM - 12NN"
          },
          {
            "time": "4AM - 1PM"
          }
        ],
        "Night-Shift": [{
            "time": "9PM - 6AM"
          },
          {
            "time": "10PM - 7AM"
          },
          {
            "time": "8PM - 5AM"
          },
          {
            "time": "7PM - 4AM"
          },
          {
            "time": "4PM - 1AM"
          },
          {
            "time": "5PM - 2AM"
          },
          {
            "time": "6PM - 3AM"
          }
        ]
      },
      timezoneId:"",
      sched_items: [],
      selectedSched: "",
      selectedTime: "",

      // Items
      departments: [],
      subdepartments:[],
      positions: [],
      sub_department_id:"",
      // Job Information
      position_id: "",
      employment_date: "",
      basic_salary: "",
      others_salary: "",
      monthly_allowance: "",
      others_allowance: "",
      date_sign: "",
      training_date: "",
      // Personal Information
      emp_id: "",
      first_name: "",
      last_name: "",
      middle_name: "",
      suffix: "",
      civil_status: "",
      birthdate: "",
      current_address: "",
      permanent_address: "",
      // Contact Information
      contact: "",
      contact_person: "",
      emergency_no: "",
      email_address: "",
      relationship: "",
      // Requirements
      sss_no: "",
      hdmf_no: "",
      mid_no: "",
      tin_no: "",
      phic_no: "",
      //Experience
      experience: [
        {
          employeer: "",
          company_address: "",
          job_title: "",
          start_date: "",
          end_date: "",
          previous_salary: "",
          reason_for_leaving: ""
        }
      ],
      dependents: [
        {
          name: "",
          relationship: "",
          age: "",
          phic_no: ""
        }
      ],
      seniors: [
        {
          senior_citizen: "",
          middle_initial: ""
        }
      ],

      // Errors handler
      error_handler: []
    }
  },
  mounted() {
    this.$store.dispatch("GET_DEPARTMENT")
    this.$store.dispatch("GET_POSITIONS")
    this.$store.dispatch("GET_SUBDEPARTMENT")
    this.$store.dispatch("GET_TIMEZONES")
  },
  methods: {
    add_experience() {
      this.experience.push({
        employeer: "",
        company_address: "",
        job_title: "",
        start_date: "",
        end_date: "",
        previous_salary: "",
        reason_for_leaving: ""
      })
    },
    deleteUser(index) {
      console.log(index)
      console.log(this.finds)
      this.experience.splice(index, 1)
      if (index === 0) this.add_experience()
    },
    add_dependent() {
      this.dependents.push({
        name: "",
        relationship: "",
        age: "",
        phic_no: ""
      })
    },
    add_senior(index) {
      this.seniors.push({
        senior_citizen: "",
        middle_initial: ""
      })

      if (index === 1) this.seniors.splice(index, 1)
    },
    deleteSenior(index) {
      console.log(index)
      console.log(this.finds)
      this.seniors.splice(index, 1)
      if (index === 0) this.add_senior()
    },
    deleteDependent(index) {
      console.log(index)
      console.log(this.finds)
      this.dependents.splice(index, 1)
      if (index === 0) this.add_dependent()
    },

    formSubmit(e) {
      e.preventDefault()
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(isConfirm => {
        if (isConfirm === true) {
          axios
            .post(
              "api/employees/add",
              {
                // PERSONAL INFORMATION
                emp_id: this.emp_id,
                position_id: this.position_id,
                sub_department_id:this.sub_department_id,
                first_name: this.first_name,
                middle_name: this.middle_name,
                last_name: this.last_name,
                suffix: this.suffix,
                civil_status: this.civil_status,
                birthdate: this.frontEndDateFormat(this.birthdate),
                current_address: this.current_address,
                permanent_address: this.permanent_address,

                //WORK SHIFT
                schedule: this.selectedSched,
                time: this.selectedTime,
                timezone_id: this.timezoneId,

                // JOB INFORMATION
                employment_date: this.frontEndDateFormat(this.employment_date),
                basic_salary: (this.basic_salary != '0') ? this.basic_salary : this.others_salary,
                monthly_allowance: (this.monthly_allowance != '0') ? this.monthly_allowance : this.others_allowance,
                date_signed: this.date_sign,
                training_date: this.training_date,

                // CONTACT
                contact: this.contact,
                contact_person: this.contact_person,
                emergency_no: this.emergency_no,
                email_address: this.email_address,
                relationship: this.relationship,

                // EXPERIENCE
                experience: JSON.stringify(this.experience),

                // REQUIREMENTS
                sss_no: this.sss_no,
                hdmf_no: this.hdmf_no,
                mid_no: this.mid_no,
                tin_no: this.tin_no,
                phic_no: this.phic_no,

                // DEPENDENTS
                dependents: JSON.stringify(this.dependents),
                seniors: JSON.stringify(this.seniors)
              }
            )
            .then(resp => {
              console.log(resp.data)
              if (resp.data.response == "error") {
                this.$swal(
                  "Error",  resp.data.message,   "error"
                )
              } else {
                this.$swal(
                  "Save",  resp.data.message, "success"
                )
                this.$router.push({ name: "new-employee"})
                this.clear_data()
                this.error_handler = ""
              }
            })
            .catch(error => {
              if (error.response.status == 422) {
                this.error_handler = error.response.data.errors
              }
              console.log("response => ", error.response.message)
            })
        }
      })
    },
    resForm(e) {
      e.preventDefault()
      this.clear_data()
      this.$swal("All feild are successfuly cleared")
    },

    clear_data() {
      // JOB INFORMATION
      this.employment_date = ""
      this.basic_salary = ""
      this.monthly_allowance = ""
      this.date_sign = ""
      this.training_date = ""
      this.date_sign = ""

      // PERSONAL INFORMATION  CLEAR
      this.emp_id = ""
      this.position_id = ""
      this.first_name = ""
      this.middle_name = ""
      this.last_name = ""
      this.civil_status = ""
      this.birthdate = ""
      this.current_address = ""
      this.permanent_address = ""

      //  CONTACT
      this.contact = ""
      this.contact_person = ""
      this.emergency_no = ""
      this.email_address = ""
      this.relationship = ""

      // EXPERIENCE
      this.experience = [
        {
          employeer: "",
          company_address: "",
          job_title: "",
          start_date: "",
          end_date: "",
          previous_salary: "",
          reason_for_leaving: ""
        }
      ]

      // REQUIREMENTS
      this.sss_no = ""
      this.hdmf_no = ""
      this.tin_no = ""
      this.phic_no = ""

      // EXPERIENCE
      this.dependents = [
        {
          name: "",
          relationship: "",
          age: "",
          phic_no: ""
        }
      ]

      // EXPERIENCE
      this.seniors = [
        {
          senior_citizen: "",
          middle_initial: ""
        }
      ]
    },


     frontEndDateFormat: function(date) {
      return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD")
     },

     hide_message_timezone_id() {
       if (!!this.error_handler.timezone_id) this.error_handler.timezone_id = false
     },

     hide_message_scheduleType() {
       if (!!this.error_handler.schedule) this.error_handler.schedule = false
     },
     hide_message_scheduleTime() {
       if (!!this.error_handler.time) this.error_handler.time = false
     },
     hide_message_employeeNo() {
       if (!!this.error_handler.emp_id) this.error_handler.emp_id = false
     },
     hide_message_departmentBelong() {
       if (!!this.error_handler.sub_department_id) this.error_handler.sub_department_id = false
     },
     hide_message_position() {
       if (!!this.error_handler.position_id) this.error_handler.position_id = false
     },
     hide_message_salary() {
       if (!!this.error_handler.basic_salary) this.error_handler.basic_salary = false
     },
     hide_message_allowance() {
       if (!!this.error_handler.monthly_allowance) this.error_handler.monthly_allowance = false
     },
     hide_message_dateHired() {
       if (!!this.error_handler.employment_date) this.error_handler.employment_date = false
     },
     hide_message_firstName() {
       if (!!this.error_handler.first_name) this.error_handler.first_name = false
     },
     hide_message_lastName() {
       if (!!this.error_handler.last_name) this.error_handler.last_name = false
     },
     hide_message_middleName() {
       if (!!this.error_handler.middle_name) this.error_handler.middle_name = false
     },
     hide_message_civilStatus() {
       if (!!this.error_handler.civil_status) this.error_handler.civil_status = false
     },
     hide_message_birthDate() {
       if (!!this.error_handler.birthdate) this.error_handler.birthdate = false
     },
     hide_message_currentAddress() {
       if (!!this.error_handler.current_address) this.error_handler.current_address = false
     },
     hide_message_permanentAddress() {
       if (!!this.error_handler.permanent_address) this.error_handler.permanent_address = false
     },
     hide_message_contactNo() {
       if (!!this.error_handler.contact) this.error_handler.contact= false
     },
     hide_message_personalEmail() {
       if (!!this.error_handler.email_address) this.error_handler.email_address = false
     },
     hide_message_emergencyNo() {
       if (!!this.error_handler.emergency_no) this.error_handler.emergency_no = false
     },
     hide_message_contactPerson() {
       if (!!this.error_handler.contact_person) this.error_handler.contact_person = false
     },
     hide_message_relationship() {
       if (!!this.error_handler.relationship) this.error_handler.relationship = false
     },

  },
  computed:{
     ...mapState([
        'departmentItem',
        'positionsItem',
        'subDepartmentItem',
        'timezoneItem'
      ]),
    },
  watch: {
    selectedSched: function () {
      // Clear previously selected values
      this.sched_items = [];
      this.time_items = [];
      this.selectedTime = "";
      // Populate list of sched_items in the second dropdown
      if (this.selectedSched.length > 0) {
        this.sched_items = this.schedules[this.selectedSched]
      }
    },
    selectedTime: function () {
      // Clear previously selected values
      this.time_items = [];
      // Now we have a continent and sched_index. Populate list of time_items in the third dropdown
      if (this.selectedTime.length > 0) {
        this.time_items = this.schedules[this.selectedSched][this.selectedTime]
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-new-employee/todo-new-employee.vue